<template>
  <div class="post-message">
    <div class="head-nav c-s" v-if="loginStatus == 1">
      <div class="left-aaaa" @click="cat()">
        <!-- <van-icon name="arrow-left"/> -->
        <img src="../assets/images/images/left_qq.png" alt />
      </div>
      <div class="title f12">
        信息提交后需审核！您可在首页右下方"我的">"我的发布"里自行下架（删除）已过时的信息！
      </div>
      <div class="login c-c f14" @click="login()">登录</div>
    </div>
    <div class="head-nav c-s" v-if="loginStatus !== 1">
      <div class="left-aaaa" @click="cat2()">
        <!-- <van-icon name="arrow-left"/> -->
        <img src="../assets/images/images/left_qq.png" alt />
      </div>
      <div class="title f12">
        信息提交后需审核！您可在首页右下方"我的">"我的发布"里自行下架（删除）已过时的信息！
      </div>
      <div class="has-login c-c f14">已登录</div>
    </div>
    <div class="content">
      <div class="wrap-textarea">
        <!-- <textarea class="mes" name="mes" id="post-mes" cols="20" rows="10"></textarea> -->
        <van-cell-group>
          <van-field
            v-model="message"
            type="textarea"
            placeholder="请留言（尽可能详细，含联系方式）"
            rows="7"
            autosize
          />
        </van-cell-group>
      </div>
      <div class="upload-file-div t-l">
        <div class="f15" style="margin-bottom: 3px">图片上传（最多9张）</div>
        <div class="c-p" style="flex-wrap: wrap">
          <!-- <div class="c-l" style="flex-wrap:wrap;width:100%;"> -->
          <template v-if="preShowIds.length != 0">
            <div
              @click="removePics(index)"
              class="wrap-load sia c-c"
              v-for="(item, index) in preShowIds"
              :key="index"
            >
              <!-- <div class="sia-close">

                </div> -->
              <van-icon name="close" class="sia-close" />
              <img :src="item" alt />
            </div>
          </template>
          <!-- </div> -->
          <div
            class="wrap-load c-c"
            style="margin: 0px 0 0 0px"
            @click="chooseImages"
          >
            <!--van-uploader :after-read="onRead"   >
              <van-icon name="plus"/>
            </van-uploader-->
            <div>
              <img src="../assets/images/images/Add.png" />
            </div>
          </div>
        </div>
      </div>
      <div class="get-user-phone c-l">
        <div>确认联系号码：</div>
        <van-cell-group :border="border">
          <van-field
            ref="userInputPhone"
            @blur="checkUserInput"
            v-model="userPhone"
            placeholder="限填单个手机号"
          />
        </van-cell-group>
      </div>
      <!-- 标签部分 -->
      <div class="tags c-c f-d-c">
        <div class="flex1 c-s one" style="flex-wrap: wrap">
          <div
            class="van-hairline--surround tags-one f12 c-c"
            :class="currentTag == index ? 'tags-one-active' : ''"
            v-for="(item, index) in list1"
            :key="index"
            @click="add(index)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <!-- 标签 -->
      <!-- 标签部分 -->
      <div class="tags c-c f-d-c" v-if="showSecondTag">
        <div class="flex1 c-s one" style="flex-wrap: wrap">
          <div
            class="van-hairline--surround tags-one f12 c-c"
            :class="currentTag2 == index ? 'tags-one-active' : ''"
            v-for="(item, index) in list2"
            :key="index"
            @click="add2(index)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div class="check-tag">
        <van-checkbox
          :disabled="!showTBMSg"
          v-model="checkedShop"
          shape="square"
          checked-color="#892785"
          >同步到我的店铺</van-checkbox
        >
      </div>
      <!-- 标签 -->
      <div class="c-start check-tag f10 c-c">
        <!-- <van-checkbox v-model="checked" checked-color="rgb(137,39,133)">
          <span style="color:grey">我已阅读并同意</span>
          <span @click="know" style="color:rgb(137,39,133)">《发布须知》</span>
        </van-checkbox>-->
      </div>
      <div class="c-start check-tag f10 c-c">
        <div
          @click="readRule()"
          :class="checked == true ? 'correct-a' : 'correct-b'"
        >
          <img src="../assets/images/images/correct_w.png" alt v-if="checked" />
          <img src="../assets/images/images/correct.png" alt v-if="!checked" />
        </div>
        <div style="margin-left: 10px">
          <span style="color: grey">我已阅读并同意</span>
        </div>
        <div @click="know" style="color: rgb(137, 39, 133)">《发布须知》</div>
        <div style="margin-left: 10px">
          <span style="color: grey">保证信息真实有效</span>
        </div>
      </div>
      <div class="sure-submit c-c">
        <div @click="sure()" class="sure-submit-btn f19 c-c">确认提交</div>
      </div>

      <van-action-sheet :title="text" v-model="show">
        <div
          class="tag-err van-hairline--bottom"
          @click="chooseTagLevelOne(index)"
          v-for="(item, index) in actions"
          :key="index"
        >
          {{ item.title }}
        </div>
      </van-action-sheet>
      <van-popup class="reset-pop" v-model="showTips">
        <div v-html="tips.content"></div>
      </van-popup>
      <div
        v-show="showLoadingPic"
        style="
          z-index: 99;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: #000;
          opacity: 0.6;
        "
      >
        <div
          style="
            z-index: 100;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            width: 50%;
            height: 50%;
          "
        >
          <van-loading size="24px" vertical color="rgb(137, 39, 133)"
            >图片上传中...</van-loading
          >
        </div>
      </div>
      <div
        @click="closeTips"
        v-if="showTips"
        style="
          z-index: 9999;
          margin: 0 auto;
          position: fixed;
          bottom: 5%;
          left: 0;
          right: 0;
          width: 30px;
          height: 30px;
        "
      >
        <img src="../assets/images/images/close.png" alt />
      </div>
      <br />
    </div>
  </div>
</template>

<script>
let me;
let beforeUrl = "";
import { ActionSheet } from "vant";
import axios from "axios";
import lrz from "lrz";
import { getData } from "../Interface/http.js";
import { postData } from "../Interface/http.js";
import { apiUrl } from "../Interface/http.js";

export default {
  name: "postMessage2",
  data() {
    return {
      checkedShop: false,
      showLoadingPic: false,
      text: "",
      showTips: false,
      actions: [],
      show: false,
      imageList: [],
      imageListShow: [],
      imageListLimit: [],
      a: "",
      tips: "",
      loginStatus: 1,
      value: "",
      userPhone: "",
      message: "",
      border: false,
      list1: [],
      list2: [],
      currentTag: -1,
      currentTag2: -1,
      realTag: -1,
      checked: true,
      // 是否上传图片
      uploadPic: false,
      showSecondTag: false,
      imgForUpList: [],
      //xhy
      localIds: [], //chooseImage返回的本地图片id,
      preShowIds: [], //预览图片地址
      serverIds: [], //uploadImage返回的服务器图片id
      showTBMSg: false, //是否展示同步到店铺
      userInfoData: "",
    };
  },
  created() {},
  mounted() {
    me = this;
    let token = localStorage.getItem("token");
    if (!token) {
      getData("/oauth/redirect/wechat").then((res) => {
        localStorage.setItem("startPage", "postMessage");
        window.location.href = res.data.redirect_url;
      });
    }
    me.getUserInfo();
    me.getConfigData();
    this.getTags();

    if (
      localStorage.getItem("token") == null ||
      localStorage.getItem("token") == "123456"
    ) {
      this.loginStatus = 1;
    } else {
      this.loginStatus = 0;
    }
  },
  beforeRouteEnter(to, from, next) {
    beforeUrl = from.fullPath;
    next();
  },
  methods: {
    getUserInfo() {
      getData("/user/info", {
        token:
          localStorage.getItem("token") != ""
            ? localStorage.getItem("token")
            : "123456",
      })
        .then((res) => {
          if (res.code == 0) {
            me.userInfoData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dataURLtoFile(dataurl, filename) {
      //3.base64转文件
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    async getTrueImageA(datas) {
      //2.调用wx.getLocalImgData获取展示图片链接地址
      me.showLoadingPic = true;
      await wx.getLocalImgData({
        localId: datas[0],
        success: function (res) {
          var localData = res.localData;
          if (localData.indexOf("data:image") != 0) {
            //判断是否有这样的头部
            localData = "data:image/jpeg;base64," + localData;
          }
          localData = localData
            .replace(/\r|\n/g, "")
            .replace("data:image/jgp", "data:image/jpeg");
          me.preShowIds.push(localData);
          let date = Date.parse(new Date());
          let a = me.dataURLtoFile(localData, date);
          me.onRead(a, datas);
        },
        fail: function (err) {},
      });
    },

    readRule() {
      this.checked = !this.checked;
    },
    closeTips() {
      this.showTips = false;
    },
    chooseImages() {
      //1.调用wx.chooseImage选择图片

      let canChooseImgNum = 9 - me.localIds.length;
      if (canChooseImgNum <= 0) {
        this.$toast("图片最多只能上传9张哦~");
        return;
      }
      wx.chooseImage({
          count: canChooseImgNum,
          success: function (res) {
            me.localIds.push(...res.localIds);
            me.getTrueImageA(res.localIds, "test");
          },
          fail: function (err) {
            console.log(err);
          },
        });
      
    },
    getConfigData() {
      //获取配置数据
      let pathname = encodeURIComponent(window.location.pathname);
      let search = encodeURIComponent(window.location.search);
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      var iPad = u.indexOf("iPad") > -1;
      var iPhone = u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1;
      let anURL =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        window.location.search; //安卓地址
      let iosURL = this.$store.state.jumpUrl; //ios地址
      let result = "";
      if (isAndroid) {
        result = anURL;
      }
      if (isiOS || iPad || iPhone) {
        result = iosURL;
      }
      //this.message=result;
      result = encodeURIComponent(result);
      getData("/oauth/credential/jssdk?debug=1&url=" + result).then((res) => {
        wx.config({
          beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
          //debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.noncestr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见附录1
          jsApiList: ["chooseImage", "uploadImage"], // 必填，需要使用的JS接口列表，所有JS接口列表见微信公众平台附录
        });
      });
    },
    removePics(index) {
      //移除图片
      this.localIds.splice(index, 1);
      this.preShowIds.splice(index, 1);
      this.serverIds.splice(index, 1);
      if (me.currentTag != "-1") {
        me.add(me.currentTag);
      }
      if (me.currentTag2 != "-1") {
        me.add2(me.currentTag2);
      }
    },
    getRecommondList() {},
    checkUserInput() {
      let regBox = {
        regEmail: /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/, //邮箱
        regName: /^[a-z0-9_-]{3,16}$/, //用户名
        regMobile: /^0?1[0-9][0-9]\d{8}$/, //手机
        regTel: /^0[\d]{2,3}-[\d]{7,8}$/,
      };

      let mobile = "18758089867";
      let tel = "0575-7678899";
      let mflag = regBox.regMobile.test(this.userPhone);
      let tflag = regBox.regTel.test(this.userPhone);
      if (!mflag) {
        this.$toast("手机号有误！如：1875***9867");
      }
    },
    getTags() {
      getData("/categories").then((res) => {
        this.list1 = res.data;
        this.list2 = res.data[9].children;
      });
    },
    onRead(file, datas) {
      //4.上传用户选中的图片
      let formData = new FormData();
      formData.append("thumb", file);
      let url = "";
      url = "http://api.jfc.jfbst.com/api/v2/upload";
      axios({
        url: url,
        processData: false, // 告诉axios不要去处理发送的数据(重要参数)
        contentType: false, // 告诉axios不要去设置Content-Type请求头
        method: "post",
        data: formData,
      }).then((res) => {
        me.showLoadingPic = false;
        this.serverIds.push(res.data.data.src);
        if (me.localIds.length > 0) {
          if (me.currentTag != "-1") {
            me.add(me.currentTag);
          }
          if (me.currentTag2 != "-1") {
            me.add2(me.currentTag2);
          }
        }
        let aa = datas;
        aa.shift();
        if (aa.length > 0) {
          me.getTrueImageA(aa);
        }
      });
    },
    add(index) {
      this.currentTag = index;

      if (this.currentTag == 9) {
        this.showSecondTag = true;
      } else {
        this.currentTag2 = "-1";
        this.showSecondTag = false;
        this.realTag = this.list1[this.currentTag].id;
      }
      if (
        this.loginStatus == 1 ||
        !me.userInfoData.shop_status ||
        me.preShowIds.length < 1
      ) {
        return;
      }
      if (this.list1[this.currentTag].is_sync == 1) {
        //如果接口返回能同步就同步
        this.showTBMSg = true;
      } else {
        this.showTBMSg = false;
        this.checkedShop = false;
      }
      // if(this.list1[this.currentTag].is_sync==1){
      //   this.checkedShop=true;
      // }else{
      //   this.checkedShop=false;
      // }
    },
    add2(index) {
      this.currentTag2 = index;
      this.realTag = this.list2[this.currentTag2].id;
      if (
        this.loginStatus == 1 ||
        !me.userInfoData.shop_status ||
        me.preShowIds.length < 1
      ) {
        return;
      }
      if (this.list2[this.currentTag2].is_sync == 1) {
        //如果接口返回能同步就同步
        this.showTBMSg = true;
      } else {
        this.showTBMSg = false;
        this.checkedShop = false;
      }
    },
    chooseTagLevelOne(index) {
      this.show = false;
      if (this.currentTag == -1) {
        this.currentTag = index;
        if (this.currentTag == 9) {
          this.showSecondTag = true;
          this.realTag = -1;
        } else {
          this.realTag = this.list1[index].id;
          this.showSecondTag = false;
        }
      } else {
        this.currentTag2 = index;
        this.realTag = this.list2[index].id;
      }
    },
    onSelect(item) {
      this.show = false;
    },
    cat() {
      this.$store.commit("UPDATEATBINDEX", { tag: 0 });
      this.$router.push({
        name: "home",
      });
    },
    getToken() {
      getData("/oauth/redirect/wechat").then((res) => {
        window.location.href = res.data.redirect_url;
      });
    },

    cat2() {
      this.$store.commit("UPDATEATBINDEX", { tag: 0 });
      this.$router.push({
        name: "home",
      });
    },
    sure() {
      if (this.message == "") {
        this.$toast.fail("输入发布内容");
      } else if (this.currentTag == -1) {
        // this.$toast.fail("请选择标签");
        this.text = "请选择一级标签";
        this.actions = this.list1;
        this.show = true;
      } else if (this.currentTag == 9 && this.currentTag2 == -1) {
        // this.$toast.fail("请选择二级标签");
        this.text = "请选择二级标签";
        this.actions = this.list2;
        this.show = true;
      } else if (this.checked == false) {
        this.$toast.fail("请先勾选同意《发布须知》");
      } else {
        this.postArticle();
      }
    },
    login() {
      getData("/oauth/redirect/wechat").then((res) => {
        localStorage.setItem("startPage", "postMessage");
        window.location.href = res.data.redirect_url;
      });
    },
    postArticle() {
      let param = {};

      let formData = new FormData();
      for (let a = 0; a < this.serverIds.length; a++) {
        formData.append("thumb[]", this.serverIds[a]);
      }
      //checkedShop
      formData.append("category", this.realTag);
      formData.append("content", this.message);
      formData.append("phone", this.userPhone);
      formData.append("sync", this.checkedShop ? 1 : 0);
      // param = new URLSearchParams(formData);
      postData("/publish-message", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          token:
            localStorage.getItem("token") != ""
              ? localStorage.getItem("token")
              : "123456",
        },
      })
        .then((res) => {
          this.data = {
            checkedShop: false,
            showLoadingPic: false,
            text: "",
            showTips: false,
            actions: [],
            show: false,
            imageList: [],
            imageListShow: [],
            imageListLimit: [],
            a: "",
            tips: "",
            loginStatus: 1,
            value: "",
            userPhone: "",
            message: "",
            border: false,
            list1: [],
            list2: [],
            currentTag: -1,
            currentTag2: -1,
            realTag: -1,
            checked: true,
            // 是否上传图片
            uploadPic: false,
            showSecondTag: false,
            imgForUpList: [],
            //xhy
            localIds: [], //chooseImage返回的本地图片id,
            preShowIds: [], //预览图片地址
            serverIds: [], //uploadImage返回的服务器图片id
            showTBMSg: false, //是否展示同步到店铺
          };
          this.$router.push({
            name: "postSuc",
          });
        })
        .catch((err) => {
          //this.$toast("发布失败");
        });
    },
    know() {
      getData("/article/agreement?option_id=3").then((res) => {
        this.tips = res.data;
        this.showTips = true;
        // this.$store.commit('UPDATEATBINDEX',{tag: -1});
        // this.$store.commit('UPDATEARTICLEDETAIL',{articleDetail: res.data});
        // this.$router.push({ name: "articleDetail", params: {
        //   detail: res.data
        // }});
      });
    },
  },
};
</script>

<style scoped>
.reset-pop {
  width: 80%;
  max-height: 70% !important;
  border-radius: 3px;
  padding: 10px;
}
.sia {
  position: relative;
}
.sia-close {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 7px;
  background: #fff;
  border-radius: 50%;
}
.post-message {
  /* padding: 0 14px; */
  box-sizing: border-box;
  background: rgb(232, 232, 232);
  min-height: 100vh;
}
.head-nav {
  min-height: 42px;
  width: 100%;
  padding: 5px 3px;
  box-sizing: border-box;
  background: rgb(232, 232, 232);
}
.head-nav .left-aaaa {
  width: 20px;
  height: 18px;
  margin-left: 5px;
}
.title {
  color: rgb(143, 143, 143);
  width: 250px;
  text-align: left;
  /* height: 52px; */
}
.login {
  color: #fff;
  background: rgb(137, 39, 133);
  width: 48px;
  height: 26px;
  border-radius: 4px;
  margin-right: 13px;
}
.has-login {
  color: #fff;
  background: rgb(169, 169, 169);
  width: 48px;
  height: 26px;
  border-radius: 4px;
  margin-right: 13px;
}
.field {
  height: 120px;
}
.field input {
  height: 110px;
}
.mes {
  width: 90%;
  height: 117px;
}
.content {
  /* padding: 13px; */
  box-sizing: border-box;
}
.wrap-textarea {
  width: 100%;
  background: #fff;
  padding: 13px;
  box-sizing: border-box;
}
.upload-file-div {
  background: #fff;
  padding: 13px;
  box-sizing: border-box;
}
.wrap-load {
  width: 59px;
  height: 59px;
  border: 1px dashed rgb(220, 220, 220);
  margin-right: 5px;
}
.wrap-load i {
  font-size: 23px;
  color: rgb(220, 220, 220);
}
.get-user-phone {
  padding: 0 13px;
  box-sizing: border-box;
  background: #fff;
}
.tags {
  padding: 10px 14px;
  box-sizing: border-box;
  background: #fff;
  margin-top: 7px;
}
.tags-one {
  width: 64px;
  height: 33px;
  color: rgb(196, 196, 196);
  margin: 0 5px 7px 0;
  border-radius: 3px;
}
.tags-one-active {
  color: rgb(137, 39, 133) !important;
  border: solid 1px rgb(137, 39, 133);
  border-radius: 3px;
  box-sizing: border-box;
}
.tags .one,
.tags .second {
  width: 100%;
}
.tags .second {
  margin: 7px 0 0 0;
}
.check-tag {
  padding: 9px 0 9px 24px;
  box-sizing: border-box;
  /* background: #fff; */
  margin-top: 10px;
}
.sure-submit {
  /* background: #fff; */
}
.sure-submit-btn {
  background: rgb(137, 39, 133);
  color: #fff;
  width: 332px;
  height: 41px;
  border-radius: 5px;
}
.tag-err {
  line-height: 2.5rem;
}
.correct-a {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgb(137, 39, 133);
}
.correct-a img {
  width: 80%;
}
.correct-b {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #e8e8e8;
  border: solid 1px rgb(137, 39, 133);
  box-sizing: border-box;
}
.correct-b img {
  width: 80%;
}
</style>
